module.exports = __webpack_public_path__ + "static/media/WorkforceExecutiveDash.0f4defb2.png";